import $ from 'jquery'
import select2 from 'select2'

export default () => {
    $(window).on('resize', () => {
        $('.select2').select2()
    }).resize()
}
